import React from 'react'
import { PropTypes } from 'prop-types'
import { flowRight } from 'lodash'
import { withRouter } from 'react-router-dom'
import { graphql } from '@apollo/client/react/hoc'
import { graphqlCurrentUserCached } from 'lib/utils/store/currentUser'

import ActionLogic from 'components/Util/ActionLogic'

import activateVehicleSharing from 'graphql/vehicle/activateVehicleSharing.gql'
import getVehicleProfileView from 'graphql/view/getVehicleProfileView.gql'
import createVehicleProfileAccessHash from 'graphql/vehicle/createVehicleProfileAccessHash.gql'
import getVehicleShare from 'graphql/vehicle/getVehicleShare.gql'
import updateVehicleShare from 'graphql/vehicle/updateVehicleShare.gql'
import shareVehicleProfileLink from 'graphql/vehicle/shareVehicleProfileLink.gql'

class VehicleProfileShareLogic extends React.Component {
    activateVehicleSharing = async (actionLogic, linkId, isActive) => {
        return actionLogic.callMutation(this.props.activateVehicleSharing, {
            variables: {
                linkId: parseInt(linkId),
                isActive,
            },
        })
    }

    createVehicleProfileAccessHash = async (actionLogic, vehicleId, comment, sharePart) => {
        const { currentUser } = this.props
        return actionLogic.callMutation(this.props.createVehicleProfileAccessHash, {
            variables: {
                vehicleId: parseInt(vehicleId),
                validFor: null,
                shareComment: comment,
                sharePartOfPage: sharePart,
            },
            refetchQueries: [{
                query: getVehicleProfileView,
                variables: {
                    vehicleId: vehicleId,
                    userId: currentUser.me.id,
                },
            }, {
                query: getVehicleShare,
                variables: {
                    vehicleId: vehicleId,
                },
            }],
            awaitRefetchQueries: true,
        })
    }

    updateVehicleProfileShare = async (actionLogic, shareId, validFor, comment, sharePart, vehicleId) => {
        return actionLogic.callMutation(this.props.updateVehicleShare, {
            variables: {
                linkId: parseInt(shareId),
                validFor: validFor,
                shareComment: comment,
                sharePartOfPage: sharePart,
            },
            refetchQueries: [{
                query: getVehicleShare,
                variables: {
                    vehicleId: vehicleId,
                },
            }],
            awaitRefetchQueries: true,
        })
    }

    sendVehicleProfileShareEmail = async (actionLogic, shareLinkId, recipientEmail, message) => {
        return actionLogic.callMutation(this.props.shareVehicleProfileLink, {
            variables: {
                shareLinkId: parseInt(shareLinkId),
                recipientEmail: recipientEmail,
                message: message
            }
        })
    }

    getRenderProps = (actionLogic) => {
        return {
            ...actionLogic,
            createVehicleShareHash: (...args) => this.createVehicleProfileAccessHash(actionLogic, ...args),
            updateVehicleProfileShare: (...args) => this.updateVehicleProfileShare(actionLogic, ...args),
            sendVehicleProfileShareEmail: (...args) => this.sendVehicleProfileShareEmail(actionLogic, ...args),
            activateVehicleSharing: (...args) => this.activateVehicleSharing(actionLogic, ...args),
        }
    }

    handleMount = (actionLogic) => {
        const { onMount } = this.props
        onMount && onMount(this.getRenderProps(actionLogic))
    }

    render () {
        const { initState, children } = this.props

        return (
            <ActionLogic initState={initState} onMount={this.handleMount}>
                {(actionLogic) => {
                    return children(this.getRenderProps(actionLogic))
                }}
            </ActionLogic>
        )
    }
}

VehicleProfileShareLogic.propTypes = {
    children: PropTypes.func.isRequired,
    initState: PropTypes.object,
}

export default flowRight(
    graphqlCurrentUserCached,
    withRouter,
    graphql(createVehicleProfileAccessHash, {
        name: 'createVehicleProfileAccessHash',
    }),
    graphql(updateVehicleShare, {
        name: 'updateVehicleShare',
    }),
    graphql(shareVehicleProfileLink, {
        name: 'shareVehicleProfileLink',
    }),
    graphql(activateVehicleSharing, {
        name: 'activateVehicleSharing',
    }),
)(VehicleProfileShareLogic)
